import { type FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { MULTIPLE_IDS_PARAM, CAMPAIGN_ID_PARAM } from "@ds/constants/router";

import { CampaignDetailsPage } from "./campaign-details-page";
import { CampaignsMainPage } from "./campaign-main-page";

const CampaignsRouteSwitch = () => {
  const { search } = useLocation();
  return search.startsWith(`?${MULTIPLE_IDS_PARAM}`) ? <CampaignDetailsPage /> : <CampaignsMainPage />;
};

export const CampaignsRouter: FC = () => (
  <Routes>
    <Route path="*" element={<CampaignsRouteSwitch />} />
    <Route path={`:${CAMPAIGN_ID_PARAM}`} element={<CampaignDetailsPage />} />
  </Routes>
);
